<template>
    <div class="v-tour-price" :class="{'is-link': link}" @click="onClick">
<!--        <template v-if="cheapestPrice === null">-->
<!--            <slot name="loading">-->
<!--                <span class="is-loading-dots"><span>.</span><span>.</span><span>.</span></span>-->
<!--            </slot>-->
<!--        </template>-->
<!--        <template v-else>-->
            <span class="c-tour-price__prefix" style="border-radius: 4px; padding:0 8px; font-size: 16px; font-weight: 800;" :class="{'is-empty': !hasPrefix}"><slot name="prefix"></slot></span>
<!--            <template v-if="hasPrefix"><br/></template>-->
            <span class="c-tour-price__price u-text-bold"
                  style="margin-left: 10px; font-size: 16px; font-weight: 800; background-color: #ff6700; border-radius: 4px; padding:0 8px;"
                  v-text="cheapestPrice"></span>
            <template v-if="hasSuffix"><br/></template>
            <span class="c-tour-price__suffix" :class="{'is-empty': !hasSuffix}"><slot name="suffix"></slot></span>
<!--        </template>-->
    </div>
</template>
<script lang="ts">
import { IFlight, ITour } from '@/store/models';
import { Component, Prop } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import { formatter } from '../app.config';
import Calculator from '../helpers/calculator';
import { ScrollAnchor } from '../store/modules/ui';
import BaseComponent from './Base';

const UiStore = namespace('ui');

        @Component
    export default class TourPrice extends BaseComponent {
        @Prop({ type: String, default: '%s' }) protected readonly format: string;

        @Prop({ type: Number }) protected readonly sid: ITour['sid'];

        @Prop({ type: String, default: null }) protected readonly price: string | null;

        @State('flights', { namespace: 'orm' }) protected readonly storedFlights: IFlight[];

        @Prop({ type: Boolean, default: false }) protected readonly link: boolean;

        @UiStore.State('scrollAnchors') protected readonly scrollAnchors: ScrollAnchor[];

        get priceAnchor(): ScrollAnchor | null {
            return this.scrollAnchors.find((anchor) => anchor.id === 'prices') || null;
        }

        get hasPrefix(): boolean {
            return !!this.$slots.hasOwnProperty('prefix');
        }

        get hasSuffix(): boolean {
            return !!this.$slots.hasOwnProperty('suffix');
        }

        protected get flight(): IFlight | null {
            return this.storedFlights.find(({ tourSid }) => tourSid === this.sid) || null;
        }

        get cheapestPrice(): string | null {
            let min = this.price;

            if (this.price === null) {
                min = Calculator.minPrice(this.flight ? this.flight.prices.map(({ adultPrice }) => adultPrice) : []);
            }

            return min ? this.format.replace('%s', formatter.asCurrency(min)) : null;
        }

        public onClick() {
            if (this.priceAnchor === null) {
                return;
            }

            window.scrollTo({
                top: (this.priceAnchor.el.elm as HTMLElement).offsetTop - 100,
                behavior: 'smooth',
            });
        }
    }
</script>
